import InsightBlock from '@components/insightBlock';
import UsageBlock from '@components/usageblock';
import UsageImage from '@components/usageimage';
import * as React from 'react';
export default {
  InsightBlock,
  UsageBlock,
  UsageImage,
  React
};